<template>	
	<div>
		<div id="message" v-if="statusMessage">{{ textMessage }}</div>
		<h1 id="total-comment">{{ comments.length }} Comment<span v-if="comments.length > 1">s</span></h1>
		<div v-if="comments.length">
			<div id="list-comment" v-for="(comment, index) in comments">
				<p v-if="comment.user_id != null" id="comment-name"><strong><a :href="`mailto:${comment.user.email}`">{{ comment.user.name }}</a></strong> · {{ comment.readable }}</p>
				<p v-else id="comment-name"><strong><a :href="`mailto:${comment.email}`">{{ comment.name }}</a></strong> · {{ comment.readable }}</p>
				<div id="comment">
					<p>{{ comment.comments }}</p>
				</div>
			</div>
		</div>
		<div id="stylized">
			<form method="post" id="formComment">
				<div class="row">
					<label style="padding-top:5px;">Comment</label>
					<textarea name="comment" rows="5" v-model="formData.comment"></textarea>
				</div>
				<div class="row">
					<input type="button" value="Send Comment" style="margin-top: 15px; padding: 10px 15px; border: 1px solid #CCC; cursor: pointer; background-color: #EFEFEF;" :disabled="isFormInvalid" v-on:click="saveComment">
				</div>
			</form>		
		</div>
	</div>
</template>

<script>
	export default {
        props: ['data'],		       
		data() {
			return {
				formData: {
					comment: "",
				},
                comments: [],
                hasSubmitted: false,
                statusMessage: false,
                textMessage: "",
			};
		},
		mounted() {
			this.getComments();
		},
		methods: {
			saveComment() {
				this.hasSubmitted = true;
				const form = new FormData(document.getElementById("formComment"));
				form.append('post_id', this.data.post_id);  
				axios.post('/api/ajax/posts/comments/insert', form).then(res => {
					this.hasSubmitted = false;
                    this.formData.comment = "";				    	
					this.statusMessage = true;
					this.textMessage = res.data.message;
			    	this.getComments();								    	
			    })
			    .catch(err => {                    
			    }) 
			},
            getComments() {
                axios.get('/api/ajax/posts/comments/' + this.data.post_id).then(res => {
                    this.comments = res.data.data;
                });
            },			
		},
		computed: {
			isFormInvalid:function () {
				if (this.formData.comment === "") {
					return true;
				}
				if (this.hasSubmitted === true) {
					return true;
				}				
				return false;
			},
		},                
	}
</script>


<style scoped>
#list-comment {
	margin-bottom: 20px;
}
#total-comment {
	border-top: 1px solid #CCC; 
	margin-top: 30px; 
	padding-top: 30px;
}
#comment {
	padding: 10px;
	background-color: aliceblue; 
	font-size: 12px;
	font-family:'Andale Mono', 'Lucida Console', 'Courier New', 'monospace';
}
#comment-name {
	margin-bottom: 5px;
}
#message {
	border: 1px solid #CCCDDD;
	background-color: #5DFCCC;
	padding: 10px;
}
</style>